module.exports = __webpack_public_path__ + "static/media/icon_list_request.8b32a240.svg";